<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form ref="form" :entry="editableEntry" :extraData="extraData" :readOnly="readOnly" :isEdit="isEdit" :modelNameSingular="modelNameSingular" />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() { return { loading: true, pageLoading: false, editableEntry: null, formErrors: [], extraData: null }; },
  props: { entry: Object, readOnly: { type: Boolean, default: false }, isEdit: { type: Boolean, default: false }, modelNameSingular: String },
  components: { Form, BaseEdit },
  methods: {
    loadServerEntry(id) {
      this.loading = true;
      this.$apollo.query({ query: LOAD_LABEL, variables: { id }, fetchPolicy: "no-cache" }).then(response => {
        this.editableEntry = response.data.accountContext.label;
        this.extraData = response.data;
      }).catch(response => console.log(response)).finally(() => (this.loading = false));
    },
    updateEntry() {
      if (!this.$refs.form.isFormValid()) return;
      this.pageLoading = true;
      this.$apollo.mutate({
        mutation: UPDATE_LABEL,
        variables: { input: this.deepFilterEntryWithAllowedFieldsForMutation(this.editableEntry, this.editableEntry.validations) }
      }).then(response => {
        const errors = response.data.updateLabel.errors;
        if (errors.length) this.formErrors = errors;
        else { this.$refs.baseEdit.closeDialog(); this.$emit("entry-updated"); this.resetForm(); }
      }).catch(response => console.log(response)).finally(() => (this.pageLoading = false));
    },
    resetForm() { if (this.$refs.form) this.$refs.form.resetFormInputs(); this.formErrors = []; },
    clearFormErrors() { this.formErrors = []; }
  }
};

const LABEL_FIELDS = `id description labelType colorId validations color { id name hexaCode }`;
const LOAD_LABEL = gql`
query($id: ID!) { 
    globalContext { 
        allColors { 
            id name hexaCode 
        }
      allLabelTypes{
        text
        value
      }
    } 
    accountContext { 
        label(id: $id) { 
            ${LABEL_FIELDS} 
        } 
    } 
}`;
const UPDATE_LABEL = gql`mutation($input: LabelUpdateInputObject!) { updateLabel(input: $input) { label { id description labelType } errors } }`;
</script>

<style scoped></style>